// @ts-check
import Axios from 'axios';

import HTTP from '@/utils/http';
import { ListTemplate } from '@/store/modules/bulkSend/models';
import Meta from '@/store/modules/models/global/Meta';

/** @typedef {import('@/store/modules/bulkSend/models/Templates').TListTemplate} TListTemplate */

/**
 * Fetch envelope
 *
 * @param {Object} options
 * @param {string} options.query
 * @param {number} options.page
 * @param {number} [options.limit=24]
 * @param {AbortSignal} options.signal
 */
export async function fetchTemplates({
 query, page, limit = 24, signal,
}) {
  // Create a new CancelToken source for this request
  const source = Axios.CancelToken.source();

  const search = new URLSearchParams({
    query,
    page: page.toString(),
    limit: limit.toString(),
  });

  const response = await HTTP({
    url: `templates?${search}`,
    cancelToken: source.token,
  });

  // Cancel the request if TanStack Query signals to abort
  signal?.addEventListener('abort', () => {
    source.cancel('Query was cancelled by TanStack Query');
  });

  return {
    templates: ListTemplate.array().parse(response.data.data),
    meta: Meta.parse(response.data.meta),
  };
}
